module.exports = __webpack_public_path__ + "040.edd49a2d.png";